module.exports = __webpack_public_path__ + "img/white2.bcb692f4.svg";